import React, { FC } from "react";
import { CampaignPrice } from "../../../../Model/CampaignPrice.csharp";
import { FeeItem } from "../../../Pricing/FeeItem.csharp";
import { getDiscount } from "../../Booking/Helpers/totalPriceCalculator";
import {formatPrice} from "../../Helpers/priceHelper";

interface BaseFeesWithCampaignProps {
  baseFees: FeeItem[];
  campaign?: CampaignPrice;
  isWeekendOrHoliday: boolean;
  isEvening: boolean;
}

export const BaseFeesWithCampaign: FC<BaseFeesWithCampaignProps> = ({
  baseFees,
  campaign,
  isWeekendOrHoliday,
  isEvening,
}) => {
  const campaignComponent = !!campaign && (
    <tr className="BaseFeesWithCampaign__detailsRow">
      <th>{campaign.discountPriceLabel ?? "Rabatt"}</th>
      <td className="BaseFeesWithCampaign__price">
        -{formatPrice(getDiscount(isWeekendOrHoliday, isEvening, campaign))}
      </td>
    </tr>
  );

  const baseFeesComponent = baseFees.map((fee, i) => (
    <tr key={i} className="BaseFeesWithCampaign__detailsRow">
      <th>{fee.label}</th>
      {fee.regularPrice != 0 && (
        <td className="BaseFeesWithCampaign__price">{formatPrice(fee.regularPrice)}</td>
      )}
    </tr>
  ));

  return !!campaign?.showBeforeBaseFees ? (
    <>
      {campaignComponent}
      {baseFeesComponent}
    </>
  ) : (
    <>
      {baseFeesComponent}
      {campaignComponent}
    </>
  );
};
